import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function decodeBase64(encoded: string): string {
  return Buffer.from(encoded, 'base64').toString('ascii');
}
